import React from 'react'

import Option from 'components/Option'

const OptionGroup = ({
  optionGroup,
  onClickOption,
  selectedOptions,
  editingOptionId,
  onEditOption,
  onSaveOption
}) => {
  // invalid is a weird concept because all multi groups are invalid
  // TODO: when equivalent groups are added, split this into multiple concepts
  const invalid = optionGroup.options.length > 1

  return (
    <div className={`option-group ${invalid ? 'option-group-invalid card mb-2 bg-danger' : '' }`}>
      <div className={invalid ? 'card-body' : ''}>
        {
          optionGroup.options.map( (option, i) => (
            <Option key={`option-${option.id}`}
              option={option}
              onClick={ () => onClickOption(option.id) }
              isLast={invalid && i == optionGroup.options.length - 1}
              selected={ selectedOptions.includes(option.id) }
              editing={editingOptionId === option.id}
              onEdit={ () => onEditOption(option.id)}
              onSave={onSaveOption}
            />
          ) )
        }
      </div>
    </div>
  )
}

export default OptionGroup
